module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-more",
      "plain": ""
    }
  }, [_vm._v("More Options")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.editable,
      "command": "edit-survey"
    }
  }, [_vm._v("Edit Survey")]), _vm._v(" "), (_vm.state === 'IS_ACTIVE') ? _c('el-dropdown-item', {
    attrs: {
      "command": "make-inactive"
    }
  }, [_vm._v("Make inactive")]) : _vm._e(), _vm._v(" "), (_vm.state === 'IS_INACTIVE') ? _c('el-dropdown-item', {
    attrs: {
      "command": "make-active"
    }
  }, [_vm._v("Make active")]) : _vm._e(), _vm._v(" "), (_vm.state === 'IS_PREVIEW') ? _c('el-dropdown-item', {
    attrs: {
      "command": "delete-survey"
    }
  }, [_vm._v("Delete survey")]) : _vm._e(), _vm._v(" "), (_vm.canShowReportSurvey) ? _c('el-dropdown-item', {
    attrs: {
      "command": "survey-report"
    }
  }, [_vm._v("Survey Report")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "favourite active pull-left",
    on: {
      "click": _vm.handleToggleFavourite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-star': _vm.favorite, 'fa-star-o': !_vm.favorite
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleSurveyTitle
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Status:")]), _vm._v(" "), _c('dd', [(_vm.state == 'IS_ACTIVE') ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (_vm.state == 'IS_INACTIVE') ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Inactive")]) : _vm._e(), _vm._v(" "), (_vm.state == 'IS_PREVIEW') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Preview")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Type:")]), _vm._v(" "), _c('dd', [(_vm.isSpotSurvey) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Spot")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Qualitative")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Start Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.startDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("End Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.endDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("Created By:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.handleDisplayName(_vm.createdBy)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Total:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.totalEntries))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a7e7c4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/SurveyListItem.vue
// module id = 3323
// module chunks = 3